<template>
  <div id="app">
    <v-app id="inspire">
      <v-app id="inspire">
        <v-main style="background-color: #e5f1e5;">
          <v-container
              class="fill-height"
              fluid
          >
            <v-row
                align="center"
                justify="center"
            >
              <v-col
                  cols="12"
                  sm="8"
                  md="4"
              >
                <v-card class="elevation-12">
                  <v-toolbar
                      color="green darken-1"
                      dark
                      flat
                  >
                    <v-toolbar-title>Система лицензирования Carbis</v-toolbar-title>
                  </v-toolbar>
                  <v-card-text>
                    <v-form>
                      <v-text-field
                          label="E-mail"
                          prepend-icon="mdi-account"
                          type="text"
                          placeholder="Введите email"
                          v-model="email"
                          color="green darken-2"
                          :hint="hint"
                          :persistent-hint="!isLoginMode"
                          @keyup.enter="submit"
                      ></v-text-field>

                      <v-text-field
                          v-if="isLoginMode"
                          label="Пароль"
                          prepend-icon="mdi-lock"
                          type="password"
                          placeholder="Введите пароль"
                          v-model="password"
                          color="green darken-2"
                          @keyup.enter="submit"
                      ></v-text-field>
                    </v-form>
                  </v-card-text>
                  <v-card-actions class="pa-4" v-if="isLoginMode">
                    <v-btn @click="isLoginMode = false" color="green darken-2" dark text large>Забыли пароль?</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="submit" color="green darken-2" dark text large>Войти</v-btn>
                  </v-card-actions>
                  <v-card-actions class="pa-4" v-else>
                    <v-btn @click="isLoginMode = true" color="green darken-2" dark text large>Войти</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="submit" color="green darken-2" dark text large>Восстановить</v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-container>

          <v-dialog
              v-model="recoveredDialog"
              max-width="400"
              persistent
          >
            <v-card>
              <v-card-title class="headline">Пароль сброшен</v-card-title>
              <v-card-text>
                Пароль сброшен и отправлен на Вашу почту. Возможно, он попал в папку "Спам".
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="green darken-2"
                    text
                    @click="recoveredDialog = false"
                >
                  ОК
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-snackbar
              v-model="$store.getters.snackbar.show"
              top
              :color="$store.getters.snackbar.color"
              :timeout="2500"
          >
            {{ $store.getters.snackbar.text }}

            <template v-slot:action="{ attrs }">
              <v-btn
                  dark
                  text
                  v-bind="attrs"
                  @click="$store.commit('hideSnackbar')"
              >
                Закрыть
              </v-btn>
            </template>
          </v-snackbar>
        </v-main>
      </v-app>
    </v-app>
  </div>
</template>

<script>
import API from "@/axios/api";

export default {
  data() {
    return {
      isLoginMode: true,
      recoveredDialog: false,
      email: '',
      password: '',
      snackbar: false,
      snackbarColor: null,
      snackbarText: '',
    };
  },
  computed: {
    hint() {
      if (!this.isLoginMode)
        return 'Для указанного email будет сгенерирован новый пароль';
      return ''
    },
  },
  methods: {
    submit() {
      if (this.isLoginMode) {
        let {email, password} = this
        this.$store.dispatch('login', {email, password})
      } else {
        API.post('users/recover', {email: this.email})
          .then((response) => {
            this.recoveredDialog = true;
            this.isLoginMode = true;
            console.log(response.data);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
}
</script>